export default __webpack_public_path__ + "static/media/tree_View.c3e162f6.svg";